/**
 * "The set of organizations changed": a create, rename, move, delete,
 * approval or rejection of a distributor, MSP or company.
 *
 * The scope bar and the org pickers read one shared, module-level cache
 * (`hooks/scopeData.ts`). Nothing told that cache an organization had been
 * created, so a new distributor stayed out of the scope bar until a full page
 * reload. The API modules call `organizationsChanged()` after each successful
 * write, and the cache refetches.
 *
 * A module of its own because the cache imports the API modules: the API
 * modules importing the cache back would be a cycle.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Run `fn` after every organization write. Returns an unsubscribe function. */
export function onOrganizationsChanged(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** Call after a successful organization write. */
export function organizationsChanged(): void {
  listeners.forEach((fn) => fn());
}
